// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grid {\n  display: grid;\n  column-gap: 30px;\n  row-gap: 30px;\n}\n@media all and (min-width: 768px) {\n.grid {\n    grid-template-columns: 1fr 1fr;\n}\n}\n", ""]);
// Exports
module.exports = exports;
